export const userNotificationsEnabeledKey = "user-notifications-enabled"
